<template>
  <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
    <el-tab-pane label="个人信息" name="first">
        <div style="width: 40vw; margin-left: 10vw; margin-top: 20px;">
            <el-form :model="pwdForm" label-width="110px" style="max-width: 420px;">
                <el-form-item label="原密码">
                    <el-input v-model="pwdForm.oldpass" type="password" show-password placeholder="请输入原密码" />
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="pwdForm.newpass" type="password" show-password placeholder="至少 6 位" />
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input v-model="pwdForm.confirmpass" type="password" show-password placeholder="再次输入新密码" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changePassword" :loading="pwdSaving">修改密码</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="width: 40vw; margin-left: 10vw; margin-top: 30px;">
            <div class="sub-header">
                <span style="font-weight: bold;">签字设置</span>
            </div>
            <!-- 全局默认签名（回退用）：未单独设置签字的公司自动使用 -->
            <el-form :model="sigForm" label-width="110px" style="max-width: 420px;">
                <div class="sig-section-title">全局默认签名（回退用）</div>
                <el-form-item label="签名姓名">
                    <el-input v-model="sigForm.signaturename" placeholder="显示在单据签字栏的姓名" />
                </el-form-item>
                <el-form-item label="签字图片">
                    <ImageUploader v-model="sigForm.signaturepath" target="signatures" :width="180" :height="90" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveSignature" :loading="sigSaving">保存全局签字</el-button>
                </el-form-item>
            </el-form>

            <!-- 按公司签名（可复用）：不同公司可设置不同签字 -->
            <el-divider style="margin: 20px 0 16px;" />
            <el-form :model="companySigForm" label-width="110px" style="max-width: 420px;">
                <div class="sig-section-title">按公司签名（可复用）</div>
                <el-form-item label="选择公司">
                    <el-select v-model="companySigProfileId" style="width: 320px"
                               :disabled="!myCompanies.length" placeholder="选择公司"
                               @change="onCompanySigSelect">
                        <el-option v-for="c in myCompanies" :key="c.id" :value="c.id"
                                   :label="c.companyname + (Number(c.is_default) === 1 ? '（默认）' : '')" />
                    </el-select>
                    <div class="form-tip" style="font-size:12px;color:#909399;line-height:1.4;">
                        未单独设置签字的公司自动使用上面的全局默认签名。
                    </div>
                </el-form-item>
                <el-form-item label="签名姓名">
                    <el-input v-model="companySigForm.signaturename" placeholder="该公司的签字姓名" />
                </el-form-item>
                <el-form-item label="签字图片">
                    <ImageUploader v-model="companySigForm.signaturepath" target="signatures" :width="180" :height="90" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="!companySigProfileId"
                               @click="saveCompanySignature" :loading="sigSaving">保存该公司签字</el-button>
                    <el-button :disabled="!companySigProfileId"
                               @click="copySignatureToAll" :loading="sigCopying">复制到全部公司</el-button>
                    <el-button type="warning" plain :disabled="!companySigProfileId"
                               @click="clearCompanySignature">清除（回退全局）</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 我的邮箱：CRM 发送邮件/单证使用本人 SMTP 配置 -->
        <div style="width: 60vw; margin-left: 10vw; margin-top: 30px;">
            <div class="sub-header">
                <span style="font-weight: bold;">我的邮箱（用于CRM发送邮件/单证）</span>
                <el-button type="primary" plain size="small" @click="addEmailAccount">+ 新增邮箱</el-button>
            </div>
            <el-table :data="emailAccounts" border stripe style="width: 100%">
                <el-table-column prop="accountname" label="账号名" min-width="120" />
                <el-table-column prop="from_name" label="发件人" min-width="120" />
                <el-table-column prop="from_email" label="发件邮箱" min-width="180" />
                <el-table-column label="SMTP 服务器" min-width="180">
                    <template #default="{ row }">
                        <span>{{ row.smtp_host }}:{{ row.smtp_port }}</span>
                        <el-tag v-if="row.smtp_secure && row.smtp_secure !== 'none'" size="small" type="info" style="margin-left: 6px">{{ row.smtp_secure }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="默认" width="90" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="Number(row.is_default) === 1" type="success">默认</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="启用" width="90" align="center">
                    <template #default="{ row }">
                        <el-switch :model-value="Number(row.is_active) === 1" disabled />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="210" align="center">
                    <template #default="{ row }">
                        <el-button type="primary" plain size="small" @click="editEmailAccount(row)">编辑</el-button>
                        <el-button type="success" plain size="small" @click="testEmailAccount(row)">测试</el-button>
                        <el-button type="danger" plain size="small" @click="deleteEmailAccount(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog v-model="emailDialogVisible" :title="isEditEmail ? '编辑邮箱账号' : '新增邮箱账号'" width="620px">
                <el-form :model="emailForm" label-width="110px">
                    <el-form-item label="账号名" prop="accountname">
                        <el-input v-model="emailForm.accountname" placeholder="如：sales" />
                    </el-form-item>
                    <el-form-item label="发件人" prop="from_name">
                        <el-input v-model="emailForm.from_name" placeholder="如：Haomai Sales" />
                    </el-form-item>
                    <el-form-item label="发件邮箱" prop="from_email">
                        <el-input v-model="emailForm.from_email" placeholder="如：sales@haomai-power.com" />
                    </el-form-item>
                    <el-form-item label="SMTP 服务器" prop="smtp_host">
                        <el-input v-model="emailForm.smtp_host" placeholder="如：smtp.exmail.qq.com" />
                    </el-form-item>
                    <el-form-item label="SMTP 端口" prop="smtp_port">
                        <el-input-number v-model="emailForm.smtp_port" :min="1" :max="65535" style="width: 180px" />
                    </el-form-item>
                    <el-form-item label="加密方式" prop="smtp_secure">
                        <el-select v-model="emailForm.smtp_secure" style="width: 180px">
                            <el-option label="TLS" value="tls" />
                            <el-option label="SSL" value="ssl" />
                            <el-option label="无" value="none" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="smtp_user">
                        <el-input v-model="emailForm.smtp_user" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="smtp_pass">
                        <el-input v-model="emailForm.smtp_pass" type="password" show-password
                                  :placeholder="isEditEmail ? '留空则不修改密码' : '请输入SMTP密码'" />
                    </el-form-item>
                    <el-form-item label="设为默认" prop="is_default">
                        <el-switch v-model="emailForm.is_default" />
                    </el-form-item>
                    <el-form-item label="启用" prop="is_active">
                        <el-switch v-model="emailForm.is_active" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <el-button @click="emailDialogVisible = false">取消</el-button>
                    <el-button @click="testEmailForm" :loading="emailTesting">测试发送</el-button>
                    <el-button type="primary" @click="saveEmailAccount" :loading="emailSaving">保存</el-button>
                </template>
            </el-dialog>
        </div>
        <!-- 我的默认公司：单证抬头（PI/CI/PL）优先使用 -->
        <div style="width: 60vw; margin-left: 10vw; margin-top: 30px;">
            <div class="sub-header">
                <span style="font-weight: bold;">我的默认公司（单证抬头优先使用）</span>
            </div>
            <el-form label-width="110px" style="max-width: 420px;">
                <el-form-item label="默认公司">
                    <el-select v-model="myDefaultProfileId" style="width: 320px"
                               :disabled="myCompanies.length <= 1" @change="saveMyDefaultCompany">
                        <el-option v-for="c in myCompanies" :key="c.id" :value="c.id" :label="c.companyname" />
                    </el-select>
                    <div v-if="myCompanies.length <= 1" class="form-tip" style="font-size:12px;color:#909399;line-height:1.4;">
                        仅有一个所属公司，自动作为默认公司。
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </el-tab-pane>
    <el-tab-pane label="公司信息" name="second">
        <el-row :gutter="8" v-if="isadmin">
            <el-col :span="8">
                <el-form-item label="选择公司" prop="companyid">
                    <el-select v-model="selectedid" @change="handleCompanyChange" style="width: 260px; margin-right: 10px">
                        <el-option v-for="option in companies" :key="option.id" :value="option.id" :label="option.companyname" />
                    </el-select>
                    <el-button type="primary" plain size="small" @click="addCompany">+ 新增公司</el-button>
                    <el-button type="danger" plain size="small"
                               :disabled="!profile.id || isNew"
                               @click="deleteCompany">删除</el-button>
                </el-form-item>
            </el-col>
        </el-row>

        <el-form :model="profile"
                 label-width="80px"
                 ref="customerForm"
                 :disabled="!isadmin"
                 style="width:60vw;margin-left: 10vw">
            <el-row :gutter="8">
                <el-col :span="24">
                    <el-form-item label="公司 Logo">
                        <ImageUploader v-model="profile.companylogopath" target="logos" :width="200" :height="100"
                                       :disabled="!isadmin" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="16">
                    <el-form-item label="公司名称" prop="companyname">
                        <el-input v-model="profile.companyname" />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="Default" property="default"><el-checkbox v-model="profile.default" @change="changedefault"/></el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="website" prop="website">
                        <el-input v-model="profile.website" />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Tell" prop="facebook">
                        <el-input v-model="profile.companytel" />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Fax" prop="linkedin">
                        <el-input v-model="profile.companyfax" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="公司邮箱" prop="companyemail">
                        <el-input v-model="profile.companyemail" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="详细地址" prop="address">
                        <el-input v-model="profile.companylocation" />
                    </el-form-item>
                    <el-form-item label="BeneficiaryBank" prop="beneficiarybank">
                        <el-input v-model="profile.beneficiarybank" />
                    </el-form-item>
                    <el-form-item label="BeneficiaryName" prop="beneficiaryname">
                        <el-input v-model="profile.beneficiaryname" />
                    </el-form-item>
                    <el-form-item label="SwiftCode" prop="swiftcode">
                        <el-input v-model="profile.swiftcode" />
                    </el-form-item>
                    <el-form-item label="AccountNo" prop="accountno">
                        <el-input v-model="profile.accountno" />
                    </el-form-item>
                    <el-form-item label="BeneficiaryBankAddress" prop="beneficiarybankaddress">
                        <el-input v-model="profile.beneficiarybankaddress" />
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div class="action-bar" v-if="isadmin">
            <el-button @click="customerDrawerVisible = false">取消</el-button>
            <el-button type="primary"
                       @click="saveCustomer">
                保存
            </el-button>
        </div>
    </el-tab-pane>
    <el-tab-pane label="系统设置" name="third">
        <div v-if="isadmin" style="width: 60vw; margin-left: 10vw; margin-top: 20px;">
            <div class="sub-header">
                <span style="font-weight: bold;">商机来源</span>
                <el-button type="primary" plain size="small" @click="saveSourceOptions" :loading="sourceSaving">保存</el-button>
            </div>
            <p style="color:#909399; font-size:13px; margin-bottom:12px;">商机来源选项，商机表单/筛选将动态读取。点标签右上角 × 删除。</p>
            <el-tag v-for="(s, i) in sourceOptions" :key="i" closable :disable-transitions="true"
                    size="large" @close="removeSource(i)"
                    style="margin-right: 8px; margin-bottom: 8px;">{{ s }}</el-tag>
            <div style="margin-top: 14px; display: flex; align-items: center; gap: 8px;">
                <el-input v-model="newSource" placeholder="输入新来源，如：LinkedIn" style="width: 260px;"
                          @keyup.enter="addSource" />
                <el-button plain @click="addSource">+ 添加</el-button>
            </div>
        </div>
    </el-tab-pane>

    <el-tab-pane label="用户管理" name="fourth" v-if="isadmin">
        <div class="sub-header">
            <span style="font-weight: bold;">用户</span>
            <el-button type="primary" plain size="small" @click="addUser">+ 新增用户</el-button>
        </div>
        <el-table :data="users" border stripe style="width: 100%">
            <el-table-column prop="uid" label="ID" width="70" />
            <el-table-column prop="uname" label="用户名" min-width="130" />
            <el-table-column prop="email" label="邮箱" min-width="180">
                <template #default="{ row }">
                    <span>{{ row.email || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="130" align="center">
                <template #default="{ row }">
                    <el-switch :model-value="Number(row.isactive) === 1"
                               :disabled="Number(row.uid) === 1"
                               inline-prompt
                               active-text="启用"
                               inactive-text="禁用"
                               @change="val => toggleUserStatus(row, val)" />
                </template>
            </el-table-column>
            <el-table-column label="所属公司" min-width="240">
                <template #default="{ row }">
                    <el-tag v-for="c in row.companies" :key="c.profileid" size="small"
                            style="margin-right: 4px; margin-bottom: 2px;">{{ c.companyname }}</el-tag>
                    <span v-if="!row.companies || row.companies.length === 0" style="color:#999;">-</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="380" align="center">
                <template #default="{ row }">
                    <el-button type="primary" plain size="small" @click="editUserCompanies(row)">编辑公司</el-button>
                    <el-button type="success" plain size="small" @click="editUserSignature(row)">签名</el-button>
                    <el-button type="warning" plain size="small" @click="resetUserPassword(row)">重置密码</el-button>
                    <el-button type="danger" plain size="small" :disabled="Number(row.uid) === 1"
                               @click="deleteUser(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新增用户 -->
        <el-dialog v-model="userDialogVisible" title="新增用户" width="520px">
            <el-form :model="userForm" label-width="110px">
                <el-form-item label="用户名" prop="uname">
                    <el-input v-model="userForm.uname" placeholder="登录账号" />
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="userForm.email" placeholder="选填" />
                </el-form-item>
                <el-form-item label="初始密码" prop="upass">
                    <el-input v-model="userForm.upass" type="password" show-password placeholder="留空则默认为用户名" />
                </el-form-item>
                <el-form-item label="所属公司" prop="profileids">
                    <el-select v-model="userForm.profileids" multiple filterable style="width: 100%"
                               placeholder="选择该用户可见/可操作的卖方公司">
                        <el-option v-for="c in companies" :key="c.id" :value="c.id" :label="c.companyname" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="userDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveNewUser" :loading="userSaving">保存</el-button>
            </template>
        </el-dialog>

        <!-- 编辑公司归属 -->
        <el-dialog v-model="userCompanyDialogVisible" :title="'编辑公司 - ' + userCompanyForm.uname" width="520px">
            <el-form :model="userCompanyForm" label-width="110px">
                <el-form-item label="所属公司" prop="profileids">
                    <el-select v-model="userCompanyForm.profileids" multiple filterable style="width: 100%"
                               placeholder="选择该用户可见/可操作的卖方公司">
                        <el-option v-for="c in companies" :key="c.id" :value="c.id" :label="c.companyname" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="userCompanyDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveUserCompanies" :loading="userSaving">保存</el-button>
            </template>
        </el-dialog>

        <!-- 重置密码 -->
        <el-dialog v-model="userPwdDialogVisible" :title="'重置密码 - ' + userPwdForm.uname" width="440px">
            <el-form :model="userPwdForm" label-width="110px">
                <el-form-item label="新密码" prop="newpass">
                    <el-input v-model="userPwdForm.newpass" type="password" show-password placeholder="至少 6 位" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="userPwdDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveUserPassword" :loading="userSaving">保存</el-button>
            </template>
        </el-dialog>

        <!-- 签名设置（管理员代设任意用户：可按公司，也可设全局默认） -->
        <el-dialog v-model="userSigDialogVisible" :title="'签名设置 - ' + userSigForm.uname" width="520px">
            <el-form :model="userSigForm" label-width="110px">
                <el-form-item label="作用公司">
                    <el-select v-model="userSigForm.profileid" clearable placeholder="不选=全局默认签名"
                               style="width:100%" @change="onUserSigCompanyChange">
                        <el-option v-for="c in userSigCompanies" :key="c.profileid"
                                   :value="c.profileid" :label="c.companyname" />
                    </el-select>
                    <div class="form-tip" style="font-size:12px;color:#909399;line-height:1.4;">
                        选择公司后为该公司的单证单独设置签字；不选则设置全局默认签字。
                    </div>
                </el-form-item>
                <el-form-item label="签名姓名">
                    <el-input v-model="userSigForm.signaturename" placeholder="显示在单据签字栏的姓名" />
                </el-form-item>
                <el-form-item label="签字图片">
                    <ImageUploader v-model="userSigForm.signaturepath" target="signatures" :width="180" :height="90" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="userSigDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveUserSignature" :loading="sigSaving">保存</el-button>
            </template>
        </el-dialog>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
    import axios from "axios";
    import Qs from "qs";
    import { post } from '@/api/index'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import ImageUploader from '@/components/ImageUploader.vue'

    export default {
        name: "settings",
        components: { ImageUploader },
        data() {
            return {
                profile: {},
                companies: [],
                activeName: "first",
                selectedid: null,
                isNew: false,
                isadmin: false,
                emailAccounts: [],
                emailDialogVisible: false,
                emailForm: {},
                isEditEmail: false,
                emailSaving: false,
                emailTesting: false,
                sourceOptions: [],
                newSource: '',
                sourceSaving: false,
                pwdForm: { oldpass: '', newpass: '', confirmpass: '' },
                pwdSaving: false,
                sigForm: { signaturepath: '', signaturename: '' },
                sigSaving: false,
                companySigForm: { signaturepath: '', signaturename: '' },
                companySigProfileId: null,
                sigCopying: false,
                userSigDialogVisible: false,
                userSigForm: {},
                userSigCompanies: [],
                users: [],
                userDialogVisible: false,
                userForm: {},
                userCompanyDialogVisible: false,
                userCompanyForm: {},
                userPwdDialogVisible: false,
                userPwdForm: {},
                userSaving: false,
                myCompanies: [],
                myDefaultProfileId: null,
            }
        },
        mounted() {
            // 获取公司信息
            const adminid = localStorage.getItem('userid')
            this.isadmin = adminid === '1' // 假设管理员的ID为1
            this.loadOwnSignature()
            this.loadProfiles()
            this.loadEmailAccounts() // 我的邮箱：所有登录用户可见
            this.loadMyCompanies() // 我的默认公司：所有登录用户可见
            if (this.isadmin) {
                this.loadUsers()
                this.loadSourceOptions()
            }
        },
        methods: {
            emptyProfile() {
                return {
                    companyname: '',
                    companyemail: '',
                    profilename: '',
                    companylocation: '',
                    companytel: '',
                    companyfax: '',
                    website: '',
                    facebook: '',
                    linkedin: '',
                    currancy: '',
                    beneficiarybank: '',
                    beneficiaryname: '',
                    swiftcode: '',
                    accountno: '',
                    beneficiarybankaddress: '',
                    companylogopath: '',
                    default: false,
                }
            },
            loadProfiles() {
                return axios({
                    url: '/apiserve/crmapi/system.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: {
                        action: 'profile',
                        Selection: 'all',
                    }
                })
                    .then(
                        response => {
                            console.log(response.data.profile)
                            const profiles = response.data?.profile || []
                            this.companies = profiles
                            // 新增态下保持当前待编辑表单，只刷新下拉列表
                            if (this.isNew) {
                                return profiles
                            }
                            let current = (this.profile && this.profile.id)
                                ? profiles.find(item => item.id == this.profile.id)
                                : null
                            if (current) {
                                this.profile = { ...current }
                                this.selectedid = current.id
                            } else {
                                this.profile = profiles.find(item => item.default === true) || profiles[0] || {}
                                this.selectedid = this.profile.id
                            }
                            return profiles
                        }
                    )
            },
            addCompany() {
                this.profile = this.emptyProfile()
                this.isNew = true
                this.selectedid = null
            },
            saveCustomer() {
                if (!this.profile.companyname || !String(this.profile.companyname).trim()) {
                    this.$message.warning('公司名称不能为空')
                    return
                }
                const isNew = this.isNew || !this.profile.id
                const data = {
                    action: 'save_profile',
                    companyname: this.profile.companyname || '',
                    companyemail: this.profile.companyemail || '',
                    profilename: this.profile.profilename || '',
                    companylocation: this.profile.companylocation || '',
                    companytel: this.profile.companytel || '',
                    companyfax: this.profile.companyfax || '',
                    website: this.profile.website || '',
                    facebook: this.profile.facebook || '',
                    linkedin: this.profile.linkedin || '',
                    currancy: this.profile.currancy || '',
                    beneficiarybank: this.profile.beneficiarybank || '',
                    beneficiaryname: this.profile.beneficiaryname || '',
                    swiftcode: this.profile.swiftcode || '',
                    accountno: this.profile.accountno || '',
                    beneficiarybankaddress: this.profile.beneficiarybankaddress || '',
                    companylogopath: this.profile.companylogopath || '',
                    default: this.profile.default ? 1 : 0,
                }
                if (!isNew) {
                    data.id = this.profile.id
                }
                axios({
                    url: '/apiserve/crmapi/system.asp',
                    method: 'post',
                    transformRequest: [function (d) {
                        return Qs.stringify(d)
                    }],
                    data: data
                })
                    .then(
                        response => {
                            const res = response.data || {}
                            if (res.result === 'saved') {
                                const savedId = (res.id != null) ? res.id : this.profile.id
                                this.$message.success(isNew ? '新增成功' : '保存成功')
                                this.isNew = false
                                this.loadProfiles().then(() => {
                                    // 刚新增的公司设为选中项
                                    if (savedId) {
                                        const saved = (this.companies || []).find(item => item.id == savedId)
                                        if (saved) {
                                            this.profile = { ...saved }
                                            this.selectedid = saved.id
                                        }
                                    }
                                }).catch(err => {
                                    console.error('loadProfiles error', err)
                                })
                            } else {
                                this.$message.error(res.error || '保存失败')
                            }
                        }
                    )
                    .catch(err => {
                        console.error('saveCustomer error', err)
                        this.$message.error('保存失败')
                    })
            },
            deleteCompany() {
                if (!this.profile.id || this.isNew) return
                const name = this.profile.companyname || ('公司#' + this.profile.id)
                this.$confirm('确定删除公司「' + name + '」？删除后不可恢复。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    axios({
                        url: '/apiserve/crmapi/system.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data)
                        }],
                        data: {
                            action: 'delete_profile',
                            id: this.profile.id,
                        }
                    })
                        .then(
                            response => {
                                const res = response.data || {}
                                if (res.result === 'deleted') {
                                    this.$message.success('删除成功')
                                    this.isNew = false
                                    this.profile = {}
                                    this.selectedid = null
                                    this.loadProfiles()
                                } else {
                                    let msg = res.error || '删除失败'
                                    if (res.documents != null) {
                                        msg += '（被 ' + res.documents + ' 单证 / ' + res.customers + ' 客户 / ' + res.opportunities + ' 商机引用）'
                                    }
                                    this.$message.error(msg)
                                }
                            }
                        )
                        .catch(err => {
                            console.error('deleteCompany error', err)
                            this.$message.error('删除失败')
                        })
                }).catch(() => {})
            },
            changedefault() {
                console.log(this.profile.id, this.profile.default)
                if (this.profile.default) {
                    this.companies.forEach(item => {
                        if (item.id !== this.profile.id) {
                            item.default = false
                        }
                    })
                    // 新增态下尚无 id，默认公司交由保存时后端统一处理
                    if (!this.isNew && this.profile.id) {
                        axios({
                            url: '/apiserve/crmapi/system.asp',
                            method: 'post',
                            transformRequest: [function (data) {
                                return Qs.stringify(data)
                            }],
                            data: {
                                action: 'setdefault',
                                id: this.profile.id,
                            }
                        })
                            .then(
                                response => {
                                    console.log(response.data)
                                }
                            )
                    }
                }
            },
            handleCompanyChange(selectedId) {
                console.log(selectedId)
                const selectedCompany = (this.companies || []).find(item => item.id == selectedId)
                if (selectedCompany) {
                    this.profile = { ...selectedCompany }
                    this.isNew = false
                }
            },
            handleClick(tab, event) {
                console.log(tab, event)
                const paneName = tab ? (tab.paneName != null ? tab.paneName : tab.name) : null
                if (paneName === 'third' && this.isadmin) {
                    this.loadSourceOptions()
                }
                if (paneName === 'fourth' && this.isadmin) {
                    this.loadUsers()
                }
            },
            async loadEmailAccounts() {
                try {
                    const res = await post('mail.asp', { action: 'email_accounts' })
                    this.emailAccounts = (res && res.success && res.data) ? res.data : []
                } catch (e) {
                    console.error('loadEmailAccounts error', e)
                    this.emailAccounts = []
                }
            },
            async loadMyCompanies() {
                try {
                    const res = await post('system.asp', { action: 'my_companies' })
                    this.myCompanies = (res && res.companies) || []
                    const def = this.myCompanies.find(c => Number(c.is_default) === 1)
                    this.myDefaultProfileId = def ? def.id
                        : (this.myCompanies.length === 1 ? this.myCompanies[0].id : null)
                } catch (e) {
                    console.error('loadMyCompanies error', e)
                    this.myCompanies = []
                    this.myDefaultProfileId = null
                }
            },
            async saveMyDefaultCompany() {
                if (!this.myDefaultProfileId) return
                try {
                    const res = await post('system.asp', {
                        action: 'set_my_default_company',
                        profileid: this.myDefaultProfileId,
                    })
                    if (res && res.result === 'done') {
                        ElMessage.success('已更新默认公司')
                        this.loadMyCompanies()
                    } else {
                        ElMessage.error((res && res.error) || '保存失败')
                    }
                } catch (e) {
                    console.error('saveMyDefaultCompany error', e)
                    ElMessage.error('保存失败')
                }
            },
            addEmailAccount() {
                this.emailForm = {
                    id: null,
                    accountname: '',
                    from_name: '',
                    from_email: '',
                    smtp_host: '',
                    smtp_port: 587,
                    smtp_secure: 'tls',
                    smtp_user: '',
                    smtp_pass: '',
                    is_default: false,
                    is_active: true,
                }
                this.isEditEmail = false
                this.emailDialogVisible = true
            },
            editEmailAccount(row) {
                this.emailForm = {
                    id: row.id,
                    accountname: row.accountname || '',
                    from_name: row.from_name || '',
                    from_email: row.from_email || '',
                    smtp_host: row.smtp_host || '',
                    smtp_port: row.smtp_port != null ? Number(row.smtp_port) : 587,
                    smtp_secure: row.smtp_secure || 'tls',
                    smtp_user: row.smtp_user || '',
                    smtp_pass: '',
                    is_default: Number(row.is_default) === 1,
                    is_active: Number(row.is_active) === 1,
                }
                this.isEditEmail = true
                this.emailDialogVisible = true
            },
            async saveEmailAccount() {
                const f = this.emailForm
                if (!f.accountname || !String(f.accountname).trim()) { ElMessage.warning('请填写账号名'); return }
                if (!f.from_email || !String(f.from_email).trim()) { ElMessage.warning('请填写发件邮箱'); return }
                if (!f.smtp_host || !String(f.smtp_host).trim()) { ElMessage.warning('请填写SMTP服务器'); return }
                if (!f.smtp_user || !String(f.smtp_user).trim()) { ElMessage.warning('请填写登录账号'); return }
                if (!this.isEditEmail && !f.smtp_pass) { ElMessage.warning('请填写登录密码'); return }
                this.emailSaving = true
                try {
                    const payload = {
                        action: 'save_email_account',
                        accountname: f.accountname,
                        from_name: f.from_name || '',
                        from_email: f.from_email,
                        smtp_host: f.smtp_host,
                        smtp_port: Number(f.smtp_port) || 587,
                        smtp_secure: f.smtp_secure || 'tls',
                        smtp_user: f.smtp_user,
                        smtp_pass: f.smtp_pass || '',
                        is_default: f.is_default ? 1 : 0,
                        is_active: f.is_active ? 1 : 0,
                    }
                    if (this.isEditEmail && f.id) {
                        payload.id = f.id
                    }
                    const res = await post('system.asp', payload)
                    if (res && res.result === 'saved') {
                        ElMessage.success(this.isEditEmail ? '保存成功' : '新增成功')
                        this.emailDialogVisible = false
                        this.loadEmailAccounts()
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveEmailAccount error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.emailSaving = false
                }
            },
            deleteEmailAccount(row) {
                ElMessageBox.confirm(
                    '确定删除邮箱账号「' + (row.accountname || row.from_email || row.id) + '」？',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                ).then(async () => {
                    try {
                        const res = await post('system.asp', { action: 'delete_email_account', id: row.id })
                        if (res && res.result === 'deleted') {
                            ElMessage.success('删除成功')
                            this.loadEmailAccounts()
                        } else {
                            ElMessage.error(res && res.error ? res.error : '删除失败')
                        }
                    } catch (e) {
                        console.error('deleteEmailAccount error', e)
                        ElMessage.error('删除失败')
                    }
                }).catch(() => {})
            },
            async testEmailAccount(row) {
                try {
                    const res = await post('mail.asp', { action: 'test', accountid: row.id })
                    if (res && res.success) {
                        ElMessage.success(res.message || '测试发送成功')
                    } else {
                        ElMessage.error(res && res.error ? res.error : '测试发送失败')
                    }
                } catch (e) {
                    console.error('testEmailAccount error', e)
                    ElMessage.error('测试发送失败')
                }
            },
            async testEmailForm() {
                const f = this.emailForm
                if (!f.smtp_host || !String(f.smtp_host).trim()) { ElMessage.warning('请填写SMTP服务器'); return }
                if (!f.from_email || !String(f.from_email).trim()) { ElMessage.warning('请填写发件邮箱'); return }
                this.emailTesting = true
                try {
                    const res = await post('mail.asp', {
                        action: 'test',
                        smtp_host: f.smtp_host,
                        smtp_port: Number(f.smtp_port) || 587,
                        smtp_secure: f.smtp_secure || 'tls',
                        smtp_user: f.smtp_user || '',
                        smtp_pass: f.smtp_pass || '',
                        from_email: f.from_email,
                        from_name: f.from_name || '',
                    })
                    if (res && res.success) {
                        ElMessage.success(res.message || '测试发送成功')
                    } else {
                        ElMessage.error(res && res.error ? res.error : '测试发送失败')
                    }
                } catch (e) {
                    console.error('testEmailForm error', e)
                    ElMessage.error('测试发送失败')
                } finally {
                    this.emailTesting = false
                }
            },

            /* ---------------- 商机来源（系统设置，仅管理员） ---------------- */
            async loadSourceOptions() {
                try {
                    const res = await post('system.asp', { action: 'get_setting', key: 'opportunity_sources' })
                    let raw = (res && res.value) ? res.value : 'MIC;Google;FB;Ins;展会;个人开发'
                    this.sourceOptions = raw.split(';').map(s => s.trim()).filter(s => s !== '')
                } catch (e) {
                    console.error('loadSourceOptions error', e)
                    this.sourceOptions = ['MIC', 'Google', 'FB', 'Ins', '展会', '个人开发']
                }
            },
            addSource() {
                const v = String(this.newSource || '').trim()
                if (!v) { ElMessage.warning('请输入来源名称'); return }
                if (this.sourceOptions.includes(v)) { ElMessage.warning('该来源已存在'); return }
                this.sourceOptions.push(v)
                this.newSource = ''
            },
            removeSource(i) {
                this.sourceOptions.splice(i, 1)
            },
            async saveSourceOptions() {
                if (!this.sourceOptions.length) { ElMessage.warning('至少保留一个来源'); return }
                this.sourceSaving = true
                try {
                    const res = await post('system.asp', {
                        action: 'save_setting',
                        key: 'opportunity_sources',
                        value: this.sourceOptions.join(';'),
                    })
                    if (res && res.result === 'saved') {
                        ElMessage.success('已保存')
                        this.loadSourceOptions()
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveSourceOptions error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.sourceSaving = false
                }
            },

            /* ---------------- 用户启用/禁用（仅管理员） ---------------- */
            async toggleUserStatus(row, val) {
                const enable = !!val
                const actionName = enable ? '启用' : '禁用'
                if (Number(row.uid) === 1 && !enable) { ElMessage.warning('管理员账号不能禁用'); return }
                try {
                    const res = await post('system.asp', {
                        action: 'user_toggle',
                        uid: row.uid,
                        isactive: enable ? 1 : 0,
                    })
                    if (res && res.result === 'ok') {
                        ElMessage.success(`已${actionName}用户「${row.uname}」`)
                        this.loadUsers()
                    } else {
                        ElMessage.error(res && res.error ? res.error : `${actionName}失败`)
                        this.loadUsers() // 恢复开关状态
                    }
                } catch (e) {
                    console.error('toggleUserStatus error', e)
                    ElMessage.error(`${actionName}失败`)
                    this.loadUsers()
                }
            },

            /* ---------------- 修改自己密码 ---------------- */
            async changePassword() {
                const f = this.pwdForm
                if (!f.oldpass) { ElMessage.warning('请输入原密码'); return }
                if (!f.newpass || f.newpass.length < 6) { ElMessage.warning('新密码长度至少 6 位'); return }
                if (f.newpass !== f.confirmpass) { ElMessage.warning('两次输入的新密码不一致'); return }
                this.pwdSaving = true
                try {
                    const res = await post('system.asp', { action: 'change_password', oldpass: f.oldpass, newpass: f.newpass })
                    if (res && res.result === 'changed') {
                        ElMessage.success('密码修改成功，下次登录请使用新密码')
                        this.pwdForm = { oldpass: '', newpass: '', confirmpass: '' }
                    } else {
                        ElMessage.error(res && res.error ? res.error : '修改失败')
                    }
                } catch (e) {
                    console.error('changePassword error', e)
                    ElMessage.error('修改失败')
                } finally {
                    this.pwdSaving = false
                }
            },

            /* ---------------- 我的签字（个人信息 tab） ---------------- */
            async loadOwnSignature() {
                const uid = localStorage.getItem('userid')
                if (!uid) { return }
                try {
                    const res = await post('documents.asp', { action: 'users', userid: uid })
                    const info = (res && res.salesinfo && res.salesinfo[0]) || {}
                    this.sigForm = {
                        signaturepath: info.signaturepath || '',
                        signaturename: info.signaturename || '',
                    }
                } catch (e) {
                    console.error('loadOwnSignature error', e)
                }
            },
            async saveSignature() {
                this.sigSaving = true
                try {
                    const res = await post('system.asp', {
                        action: 'save_signature',
                        signaturepath: this.sigForm.signaturepath || '',
                        signaturename: this.sigForm.signaturename || '',
                    })
                    if (res && res.result === 'saved') {
                        ElMessage.success('全局签字已保存')
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveSignature error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.sigSaving = false
                }
            },

            /* ---------------- 我的按公司签字（个人信息 tab） ---------------- */
            onCompanySigSelect(pid) {
                const c = this.myCompanies.find(x => Number(x.id) === Number(pid))
                this.companySigForm = c ? {
                    signaturepath: c.signaturepath || '',
                    signaturename: c.signaturename || '',
                } : { signaturepath: '', signaturename: '' }
            },
            async saveCompanySignature() {
                if (!this.companySigProfileId) { ElMessage.warning('请先选择公司'); return }
                this.sigSaving = true
                try {
                    const res = await post('system.asp', {
                        action: 'save_signature',
                        profileid: this.companySigProfileId,
                        signaturepath: this.companySigForm.signaturepath || '',
                        signaturename: this.companySigForm.signaturename || '',
                    })
                    if (res && res.result === 'saved') {
                        ElMessage.success('该公司签字已保存')
                        await this.loadMyCompanies()
                        if (this.companySigProfileId) this.onCompanySigSelect(this.companySigProfileId)
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveCompanySignature error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.sigSaving = false
                }
            },
            async copySignatureToAll() {
                if (!this.companySigProfileId) { ElMessage.warning('请先选择公司'); return }
                try {
                    await ElMessageBox.confirm(
                        '将当前签字复制到你的全部公司？将覆盖各公司现有签字。',
                        '提示',
                        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
                    )
                } catch (e) { return }
                this.sigCopying = true
                try {
                    for (const c of this.myCompanies) {
                        await post('system.asp', {
                            action: 'save_signature',
                            profileid: c.id,
                            signaturepath: this.companySigForm.signaturepath || '',
                            signaturename: this.companySigForm.signaturename || '',
                        })
                    }
                    ElMessage.success('已复制到全部公司')
                    await this.loadMyCompanies()
                    if (this.companySigProfileId) this.onCompanySigSelect(this.companySigProfileId)
                } catch (e) {
                    console.error('copySignatureToAll error', e)
                    ElMessage.error('复制失败')
                } finally {
                    this.sigCopying = false
                }
            },
            async clearCompanySignature() {
                if (!this.companySigProfileId) { ElMessage.warning('请先选择公司'); return }
                this.sigSaving = true
                try {
                    const res = await post('system.asp', {
                        action: 'save_signature',
                        profileid: this.companySigProfileId,
                        signaturepath: '',
                        signaturename: '',
                    })
                    if (res && res.result === 'saved') {
                        ElMessage.success('已清除该公司签字，将回退到全局签名')
                        this.companySigForm = { signaturepath: '', signaturename: '' }
                        await this.loadMyCompanies()
                        if (this.companySigProfileId) this.onCompanySigSelect(this.companySigProfileId)
                    } else {
                        ElMessage.error(res && res.error ? res.error : '清除失败')
                    }
                } catch (e) {
                    console.error('clearCompanySignature error', e)
                    ElMessage.error('清除失败')
                } finally {
                    this.sigSaving = false
                }
            },

            /* ---------------- 用户签名（管理员代设：按公司/全局） ---------------- */
            async editUserSignature(row) {
                this.userSigForm = { uid: row.uid, uname: row.uname, signaturepath: '', signaturename: '', profileid: '' }
                this.userSigCompanies = (row.companies || []).map(c => ({ ...c }))
                this.userSigDialogVisible = true
                try {
                    const res = await post('documents.asp', { action: 'users', userid: row.uid })
                    const info = (res && res.salesinfo && res.salesinfo[0]) || {}
                    this.userSigForm.signaturepath = info.signaturepath || ''
                    this.userSigForm.signaturename = info.signaturename || ''
                } catch (e) {
                    console.error('editUserSignature load error', e)
                }
            },
            async onUserSigCompanyChange(pid) {
                const uid = this.userSigForm.uid
                if (!uid) return
                if (!pid) {
                    // 未选公司 → 回填全局默认签名
                    try {
                        const res = await post('documents.asp', { action: 'users', userid: uid })
                        const info = (res && res.salesinfo && res.salesinfo[0]) || {}
                        this.userSigForm.signaturepath = info.signaturepath || ''
                        this.userSigForm.signaturename = info.signaturename || ''
                    } catch (e) { console.error('onUserSigCompanyChange load global error', e) }
                    return
                }
                // 选公司 → 从 user_list 已带出的公司级签字回填（无需额外请求）
                const c = this.userSigCompanies.find(x => Number(x.profileid) === Number(pid))
                if (c) {
                    this.userSigForm.signaturepath = c.signaturepath || ''
                    this.userSigForm.signaturename = c.signaturename || ''
                }
            },
            async saveUserSignature() {
                const f = this.userSigForm
                if (!f.uid) { return }
                this.sigSaving = true
                try {
                    const payload = {
                        action: 'save_signature',
                        uid: f.uid,
                        signaturepath: f.signaturepath || '',
                        signaturename: f.signaturename || '',
                    }
                    if (f.profileid) {
                        payload.profileid = f.profileid
                    }
                    const res = await post('system.asp', payload)
                    if (res && res.result === 'saved') {
                        ElMessage.success('签名已保存')
                        this.userSigDialogVisible = false
                        this.loadUsers()
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveUserSignature error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.sigSaving = false
                }
            },

            /* ---------------- 用户管理（仅管理员） ---------------- */
            async loadUsers() {
                try {
                    const res = await post('system.asp', { action: 'user_list' })
                    this.users = (res && res.users) ? res.users : ((res && res.data) ? res.data : [])
                } catch (e) {
                    console.error('loadUsers error', e)
                    this.users = []
                }
            },
            addUser() {
                this.userForm = { uname: '', email: '', upass: '', profileids: [] }
                this.userDialogVisible = true
            },
            async saveNewUser() {
                const f = this.userForm
                if (!f.uname || !String(f.uname).trim()) { ElMessage.warning('请填写用户名'); return }
                this.userSaving = true
                try {
                    const payload = {
                        action: 'user_add',
                        uname: String(f.uname).trim(),
                        email: f.email || '',
                        upass: f.upass || '',
                        profileids: (f.profileids || []).join(','),
                    }
                    const res = await post('system.asp', payload)
                    if (res && res.result === 'created') {
                        ElMessage.success('新增成功')
                        this.userDialogVisible = false
                        this.loadUsers()
                    } else {
                        ElMessage.error(res && res.error ? res.error : '新增失败')
                    }
                } catch (e) {
                    console.error('saveNewUser error', e)
                    ElMessage.error('新增失败')
                } finally {
                    this.userSaving = false
                }
            },
            editUserCompanies(row) {
                this.userCompanyForm = {
                    uid: row.uid,
                    uname: row.uname,
                    profileids: (row.companies || []).map(c => c.profileid),
                }
                this.userCompanyDialogVisible = true
            },
            async saveUserCompanies() {
                const f = this.userCompanyForm
                if (!f.uid) { return }
                this.userSaving = true
                try {
                    const res = await post('system.asp', {
                        action: 'user_save_companies',
                        uid: f.uid,
                        profileids: (f.profileids || []).join(','),
                    })
                    if (res && res.result === 'saved') {
                        ElMessage.success('已更新所属公司')
                        this.userCompanyDialogVisible = false
                        this.loadUsers()
                    } else {
                        ElMessage.error(res && res.error ? res.error : '保存失败')
                    }
                } catch (e) {
                    console.error('saveUserCompanies error', e)
                    ElMessage.error('保存失败')
                } finally {
                    this.userSaving = false
                }
            },
            resetUserPassword(row) {
                this.userPwdForm = { uid: row.uid, uname: row.uname, newpass: '' }
                this.userPwdDialogVisible = true
            },
            async saveUserPassword() {
                const f = this.userPwdForm
                if (!f.newpass || f.newpass.length < 6) { ElMessage.warning('新密码长度至少 6 位'); return }
                this.userSaving = true
                try {
                    const res = await post('system.asp', { action: 'user_reset_password', uid: f.uid, newpass: f.newpass })
                    if (res && res.result === 'saved') {
                        ElMessage.success('密码已重置')
                        this.userPwdDialogVisible = false
                    } else {
                        ElMessage.error(res && res.error ? res.error : '重置失败')
                    }
                } catch (e) {
                    console.error('saveUserPassword error', e)
                    ElMessage.error('重置失败')
                } finally {
                    this.userSaving = false
                }
            },
            deleteUser(row) {
                if (Number(row.uid) === 1) { ElMessage.warning('管理员账号不能删除'); return }
                ElMessageBox.confirm(
                    '确定删除用户「' + row.uname + '」？删除后不可恢复。',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                ).then(async () => {
                    try {
                        const res = await post('system.asp', { action: 'user_delete', uid: row.uid })
                        if (res && res.result === 'deleted') {
                            ElMessage.success('删除成功')
                            this.loadUsers()
                        } else {
                            ElMessage.error(res && res.error ? res.error : '删除失败')
                        }
                    } catch (e) {
                        console.error('deleteUser error', e)
                        ElMessage.error('删除失败')
                    }
                }).catch(() => {})
            },
        }
    }
</script>

<style scoped>
.customer-management {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.customer-list {
  margin-bottom: 15px;
  flex-shrink: 0;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.search-input {
  width: 300px;
}

.pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.demo-tabs {
  height: 100%;
}

.action-bar {
  margin-top: 20px;
  text-align: right;
}

.add-contact-form {
  margin-top: 15px;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
}

.add-contact-form .el-form-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.sub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.time-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.el-row {
  margin-bottom: 10px;
}
.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 4px;
}

:deep(.el-drawer__body) {
  padding: 20px;
}

:deep(.el-tabs__content) {
  padding: 0 20px;
  /* 修复(2026-09-11)：Element Plus 默认 .el-tabs__content{overflow:hidden} + 本页 .demo-tabs{height:100%}，
     表单比视口高时内容被整体裁掉且不产生滚动条（个人信息/公司信息 tab 底部不可见）→ 允许纵向滚动 */
  overflow-y: auto;
}

:deep(.el-form-item__label) {
  font-weight: bold;
}

:deep(.el-table) {
  margin-top: 10px;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

:deep(.el-drawer__header) {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
</style>